<template>
  <div class="content">
    <el-row>
      <el-col :span="3">
        <img class="leftcloud" v-lazy="require('../../assets/imgs/abort_back3.png')" />
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="14">
        <div class="one">
          中版行知（广州）数字传媒有限公司简称“中版行知”，Rouse soul 是中版行知旗下商标logo，愿景是希望能助力唤醒现代教育下阅读、朗读等国学文化的动力。
          产品以看听读诵学书籍为主，其内容包含从儿童绘本到中外名著，国学经典等海量优秀读物。
          精心打造并推出多种数字设备产品，深化融合诵读教室、阅读教室、智慧阅览室等多样化场景。
        </div>
        <div class="two">
          产品理念主要是以培养青少年阅读习惯为己任，让青少年能进行健康的“护眼阅读”，从小养成“爱读书，多读书，读好书”的阅读习惯。致力于用先进的特色创新文化产品和持续的教育热情，为青少年提供更个性化一对一服务的阅读产品，弘扬优秀的中华文化，开启智能阅读新时代，为社会进步做出贡献。
        </div>
        <div class="three">
          <el-row>
            <el-col :span="2">
              <span>
                <p>公司</p>
                <p>愿景</p>
              </span>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="21" class="three_detail">
              立志于中国优秀传统文化与世界多元文化相融合，实现中国传统文化走向世界各地，唤醒新的人类文明，引领人类文明走向新纪元。
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="3">
        <img class="cloud" v-lazy="require('../../assets/imgs/abort_back2.png')" />
        <img class="rightcloud" v-lazy="require('../../assets/imgs/abort_back5.png')" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "pcAbort",
  data () {
    return {
      msg: "这是PC的关于我们页"
    };
  }
};
</script>

<style scoped>
.one {
  background-image: url("../../assets/imgs/abort_back1.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 10vh;
  padding: 60px 50px;
  font-size: 23px;
  font-weight: bolder;
  line-height: 4vh;
  text-align: left;
}
.cloud {
  position: relative;
  right: 14.5vw;
  top: 20vh;
}
.leftcloud {
  position: relative;
  left: 0;
  top: 70vh;
}
.rightcloud {
  position: relative;
  right: 18.5vw;
  top: 28.5vh;
}
.two {
  margin-top: 10vh;
  font-size: 23px;
  text-align: left;
  line-height: 4vh;
}
.three {
  background-image: url("../../assets/imgs/abort_back4.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 5vh;
  padding: 60px 50px;
  font-size: 23px;
  font-weight: bolder;
  text-align: left;
}
.three span {
  display: inline-block;
  width: 5vw;
  height: 5vw;
  text-align: center;
  font-size: 34px;
  color: #890101;
}
.three_detail {
  margin-top: 0.5vh;
  line-height: 4vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/abort.vue